<template>
  <div class="p-2 d-flex" :class="isOdd ? 'ODD': 'EVEN'">
    <div v-html="message" @click="handleClick" class="MESSAGE">
    </div>
  </div>
</template>

<script>

export default {
  name: 'action-item',
  props: {
    message: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isOdd () {
      return this.index % 2 === 1;
    },
  },
  methods: {
    handleClick () {
      const quotes = this.message.split('"');
      const url = quotes.filter(quote => quote.includes('https'));
      this.$events.$emit(this.$events.URL_CLICK, { toURL: url[0] });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

  .ODD {
    background-color: white;
  }
  .EVEN {
    background-color: $color-gray20;
  }
  .MESSAGE {
    padding-left: $unit * 1.5;
    font-size: 14px;
  }
  .CHECK {
    padding-top: $unit * 0.5;
  }

</style>
